import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';

type Status = 'loading' | 'ok' | 'error';

/**
 * Landing for T08 LINK_AUTO_EXTENSION (?token=...).
 * Calls POST /auth/auto-extend and shows the result.
 */
const AutoExtendPage: React.FC = () => {
  const [params] = useSearchParams();
  const [status, setStatus] = useState<Status>('loading');
  const [message, setMessage] = useState('Activando tus días adicionales…');
  const [daysAdded, setDaysAdded] = useState<number | null>(null);

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Enlace inválido: falta el token de extensión.');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const res = await axios.post('/auth/auto-extend', { token });
        if (cancelled) return;
        setStatus('ok');
        setDaysAdded(typeof res.data?.days_added === 'number' ? res.data.days_added : null);
        setMessage(res.data?.message || 'Prueba extendida correctamente.');
      } catch (err: any) {
        if (cancelled) return;
        setStatus('error');
        const detail = err?.response?.data?.detail;
        setMessage(
          typeof detail === 'string'
            ? detail
            : 'No pudimos activar la extensión. El enlace puede haber expirado o ya fue usado.'
        );
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-xl p-8 text-center shadow-sm">
        <h1 className="text-xl font-semibold text-slate-900 mb-3">Extensión de prueba</h1>
        <p className="text-slate-600 text-sm mb-6">{message}</p>
        {status === 'ok' && daysAdded != null && (
          <p className="text-emerald-700 text-sm font-medium mb-6">
            Se añadieron {daysAdded} día{daysAdded === 1 ? '' : 's'} a tu prueba.
          </p>
        )}
        {status === 'loading' && (
          <div className="mx-auto w-8 h-8 border-2 border-slate-300 border-t-slate-700 rounded-full animate-spin mb-4" />
        )}
        <Link
          to="/"
          className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-slate-900 text-white text-sm hover:bg-slate-800"
        >
          Ir a Reveca
        </Link>
      </div>
    </div>
  );
};

export default AutoExtendPage;
